const path = require('path')

module.exports = {
  fontSize: 16,
  fontFamily: 'sans-serif',
  fontDir: path.join(__dirname, '..', 'fonts/'),
  fontFamilyMappings: { 'sans-serif': 'OpenSans-Regular.ttf' }
}
